import { LuCameraOff, LuCalendarX2 } from "react-icons/lu";
import { Button, Icon, Notice } from "../../../../components/design";
import useTranslator from "../../../../hooks/useTranslator";
import {
  haveValue,
  getKycConsiderResult,
  KYC_TOOLTIP_PRIORITY,
} from "../../../../helper/common";
import { KYC_STEP, KycStep } from "../hooks/useKycWorkflow";
import styles from "../authenticateYourId.module.css";

interface IVerificationModal {
  showPopup: boolean;
  isGuarantor: boolean;
  heading: string;
  subheading: string;
  closeModalState: (value: boolean) => void;
  hideBackgroundImage?: boolean;
  buttonText?: string;
  setKycStep: (value: KycStep) => void;
  workflowResult?: Record<string, any> | null;
}

const getFailureIcon = (path: string) => {
  if (path?.startsWith("data_validation")) return LuCalendarX2;
  return LuCameraOff;
};

const getBreakdownInfo = (
  workflowResult: Record<string, any> | null | undefined,
  _t: (key: string) => string
) => {
  // workflowResult: KYC status response (kyc_checks = provider-neutral checks).
  const kycChecks = workflowResult?.kyc_checks;

  if (!kycChecks) return null;

  for (const entry of KYC_TOOLTIP_PRIORITY) {
    if (getKycConsiderResult(kycChecks, entry.path)) {
      return {
        explanation: _t(entry.explanation),
        recommendedAction: _t(entry.recommended_action),
        icon: getFailureIcon(entry.path),
      };
    }
  }

  return null;
};

const VerificationFailedModal = ({
  showPopup,
  isGuarantor,
  heading,
  subheading,
  closeModalState,
  hideBackgroundImage,
  buttonText,
  setKycStep,
  workflowResult,
}: IVerificationModal) => {
  const { _t } = useTranslator();
  const breakdownInfo = getBreakdownInfo(workflowResult, _t);
  const FailureIcon = breakdownInfo?.icon;

  const tryAgain = () => {
    setKycStep(KYC_STEP.CAPTURE_FRONT);
    closeModalState(false);
  };
  return (
    <>
      {showPopup && (
        <div
          className={`${styles.kycVerificationFailedOverlay} ${styles.overlay} popup-overlay fixed inset-0 flex items-center justify-center z-50 wrapper-modal modal-fixed-screen ${
            isGuarantor ? "guarantorBg" : ""
          } ${hideBackgroundImage ? "hideBackgroundImage" : ""}`}
        >
          <div
            className={`${styles.kycVerificationFailed} ${styles.authModalSurface} popup-content2 popup-content bg-white kycDonePopup position-relative`}
            role="dialog"
            aria-modal="true"
            aria-labelledby="kyc-verification-failed-heading"
            aria-describedby="kyc-verification-failed-subheading"
          >
            <div className="kyc-failed-close-top-button">
              <Button
                variant="secondary"
                iconOnly
                iconStart={<Icon name="close" size={18} />}
                onClick={() => closeModalState(false)}
                aria-label={_t("close")}
              />
            </div>
            <div className="row relativeposition mt-3 mb-2">
              <div className="col-12 d-flex gap-4 align-items-center justify-content-center heading-section">
                <div className="authenticateid-header text-center">
                  <img
                    className="kyc-failed-heading-icon"
                    src="/images/high-risk-icon.svg"
                    alt=""
                  />
                  <h4 id="kyc-verification-failed-heading">{heading}</h4>
                  <p id="kyc-verification-failed-subheading">{subheading}</p>
                </div>
              </div>
            </div>
            {breakdownInfo && FailureIcon && (
              <Notice tone="danger" className={styles.kycFailedNotice}>
                <span>{breakdownInfo.explanation}</span>{" "}
                {/* <span>{breakdownInfo.recommendedAction}</span> */}
              </Notice>
            )}
            <div className={styles.kycFailedActions}>
              <Button
                size="lg"
                block
                iconStart={<Icon name="refresh" />}
                onClick={tryAgain}
              >
                <span>
                  {haveValue(buttonText) ? _t(buttonText!) : _t("tryAgain")}
                </span>
              </Button>
              <Button
                variant="secondary"
                size="lg"
                block
                onClick={() => closeModalState(false)}
              >
                {haveValue(buttonText) ? _t(buttonText!) : _t("goBack")}
              </Button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default VerificationFailedModal;
